import text from '../../constants/Login'

export const unknownErrorMessage = [
  'Ocorreu um erro desconhecido, se o erro persistir, contate o suporte.',
  'An unknown error has occurred, if the error persists, contact support.',
  'Ha ocurrido un error desconocido, si el error persiste, comuníquese con el soporte.'
]

export const customLoginErrorMessage = err => {
  const language = localStorage.getItem('language')

  switch (err.statusCode) {
    case 400:
      return text.nFound[language]
    case 401:
      return text.invalid[language]
    case 404:
      return text.nFound[language]
    default:
      return unknownErrorMessage[language]
  }
}

export const customResetPasswordErrorMessage = err => {
  const language = localStorage.getItem('language')

  switch (err.statusCode) {
    case 400:
      return text.nFound[language]
    case 401:
      return text.authError[language]
    case 403:
      return text.invalidInvite[language]
    case 404:
      return text.nFound[language]
    default:
      return unknownErrorMessage[language]
  }
}

export const customSendResetPasswordEmailErrorMessage = err => {
  const language = localStorage.getItem('language')
  switch (err.statusCode) {
    case 404:
      return text.emailNotFound[language]
    default:
      return text.sendEmailError[language]
  }
}

export const customPostNotificationPushRegisterErrorMessage = err => {
  const language = localStorage.getItem('language')
  switch (err.statusCode) {
    case 404:
      return text.pushNotificationRegisterError[language]
    default:
      return text.pushNotificationRegisterError[language]
  }
}

export const generalErrorMessage = err => {
  const language = localStorage.getItem('language')

  switch (err.statusCode) {
    case 401:
      return text.authError[language]
    default:
      return unknownErrorMessage[language]
  }
}



// WEBPACK FOOTER //
// ./src/services/Api/customErrorMessages.js